export default "__VITE_ASSET__318b4b16__"